import { call, put } from 'redux-saga/effects';
import { OffersAsyncActions } from 'store/actions/offers';
import { apiCall } from 'utils/apiCall';

function* fetch(action) {
  const {
    FetchOffer: {
      Actions: { SUCCESS, FAILURE },
    },
  } = OffersAsyncActions;
  const {
    payload: { id },
  } = action;

  try {
    const response = yield call(apiCall, `/offers/${id}`, 'get');
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default fetch;
